<h1>{{ h1Header }}</h1>
<div class="collapsible-container card-bg" [ngClass]="{ 'collapsible-container--collapsed': collapsed, '': !collapsed }">
    <div class="header-light collapsible-container__header dh" (click)="clickEvent()">
        <h2 class="h5-v2 collapsible-container__title">{{ h2Header }}</h2>
        <div class="h5-v2 collapsible-container__arrow"><span class="theme-arrow-down"></span></div>
    </div>
    <div class="collapsible-container__content">
        <div [vnDynamicHtml]="sitecoreHtml"></div>
    </div>
    <div class="collapsible-container__footer dh text-center" (click)="clickEvent()">
        <span class="animated-underline">{{ collapsed ? 'Show More' : 'Show Less' }}</span>
    </div>
</div>
